var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobyTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5533V0H2.38201V15.5533H0Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86923 15.6834C8.14463 15.6834 6.75399 15.1518 5.69787 14.0783C4.64148 13.0152 4.11328 11.6163 4.11328 9.87011C4.11328 8.12391 4.64148 6.72469 5.70867 5.65086C6.76506 4.57702 8.15542 4.04578 9.86923 4.04578C11.583 4.04578 12.9737 4.58809 14.0406 5.66192C15.1078 6.73576 15.636 8.14577 15.636 9.87011C15.636 11.5944 15.1078 13.0155 14.0514 14.0783C12.9842 15.1521 11.5938 15.6834 9.86923 15.6834ZM9.86923 13.6444C10.8609 13.6444 11.6694 13.2864 12.2836 12.5814C12.8981 11.8764 13.1997 10.9763 13.1997 9.86983C13.1997 8.76334 12.8979 7.85248 12.2836 7.14747C11.6691 6.44247 10.8609 6.0955 9.86923 6.0955C8.87758 6.0955 8.07988 6.44247 7.47643 7.14747C6.8619 7.85248 6.56031 8.75255 6.56031 9.86983C6.56031 10.9871 6.86218 11.8872 7.47643 12.5922C8.08016 13.2972 8.87758 13.6442 9.86923 13.6442V13.6444Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2087 5.6074C28.1896 6.64859 28.6854 8.06939 28.6854 9.86982C28.6854 11.6702 28.1896 13.0044 27.1871 14.078C26.1847 15.1518 24.9128 15.6831 23.3498 15.6831C21.7867 15.6831 20.4932 15.0865 19.6634 13.9042L19.3724 15.5528H17.3027V0H19.6847V5.86777C20.5793 4.6531 21.8081 4.04576 23.3495 4.04576C24.8909 4.04576 26.2168 4.5665 27.2085 5.60768L27.2087 5.6074ZM25.3546 12.614C25.9584 11.909 26.26 10.9979 26.26 9.87009C26.26 8.7423 25.9581 7.85274 25.3439 7.14774C24.7293 6.44273 23.9319 6.09576 22.9511 6.09576C21.9702 6.09576 21.1725 6.44273 20.569 7.13695C19.9653 7.84195 19.6637 8.74203 19.6637 9.84851C19.6637 10.955 19.9656 11.8985 20.569 12.6035C21.1728 13.3085 21.9702 13.6666 22.9511 13.6666C23.9319 13.6666 24.7404 13.3196 25.3546 12.6146V12.614Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0906 15.6184L28.6929 4.17584H31.2367L34.3841 12.8202L37.4561 4.17584H40L34.8799 17.3322C34.6751 17.8418 34.5028 18.2541 34.3625 18.5469C34.2117 18.8396 34.0283 19.1 33.8127 19.3495C33.3816 19.8268 32.8426 20.0003 32.0234 20.0003H29.4687V17.8853H31.1393C31.592 17.8853 31.9155 17.8095 32.0986 17.6684C32.2818 17.5273 32.4652 17.2129 32.6484 16.7356L33.0903 15.6184H33.0906Z",
    fill: "#022B3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobyTextLogo);
export default __webpack_public_path__ + "static/media/LobyTextLogo.39d547b383cf1f83b90020cfc58f2fe5.svg";
export { ForwardRef as ReactComponent };